<template>
  <div>
    <p class="mt-2">Please note that the relevancy you select here will be used to display jobs and content on the platform for campaign participants.</p>
    <advanced-form
      class="mt-2"
      autocomplete="off"
      layout="inline-md-3"
      :submit-label="$t('content-fetch.buttons.update-campaign')"
      v-bind="formFields"
      v-model="form"
      @submit="input()"
    />
  </div>
</template>

<script>
import AdvancedForm from '@src/components/AdvancedForm';
import UpdateCampaignMutation from '@/graphql/mutations/UpdateCampaign.gql';
import { mapRoot } from '@src/mixins/root';

export default {
  props: {
    campaign: {
      type: Object,
    },
  },
  components: {
    AdvancedForm,
  },
  data: () => ({
    form: {},
  }),
  created() {
    const { campaign: { preferences } } = this;
    const {
      jobRelevancy,
      contentRelevancy,
    } = preferences || {};
    this.form = {
      'preferences.jobRelevancy': jobRelevancy || 'MANUAL',
      'preferences.contentRelevancy': contentRelevancy || 'MANUAL',
    };
  },
  computed: {
    ...mapRoot([ 'company' ]),
    sitePreferences() {
      const { sitePreferences } = this.company || {};
      return sitePreferences || {};
    },
    formFields() {
      const { isLocationRelevancyForMessagesEnabled } = this.sitePreferences || {};
      const form = {
        'preferences.jobRelevancy': {
          label: 'Job relevancy',
          type: 'SELECT',
          choices: [
            { value: 'MANUAL', text: 'Select jobs manually for every message' },
            { value: 'PINNED', text: 'Add pinned jobs automatically to messages' },
            { value: 'ALL', text: 'Add randomly from selected campaign jobs to every message automatically' },
            { value: 'LOCATION', text: 'Add jobs from the user\'s location to messages automatically', disabled: !isLocationRelevancyForMessagesEnabled },
            { value: 'DEPARTMENT', text: 'Add jobs from the user\'s department to messages automatically', disabled: true },
            { value: 'LOCATION_DEPARTMENT', text: 'Add jobs from the user\'s location and department to messages automatically', disabled: true }
          ],
        },
        'preferences.contentRelevancy': {
          label: 'Content relevancy',
          type: 'SELECT',
          choices: [
            { value: 'MANUAL', text: 'Select content manually for every message' },
            { value: 'ALL', text: 'Add randomly from selected campaign content to every message automatically' }
          ],
        },
      };

      return { form };
    },
  },
  methods: {
    async input() {
      const { campaign: { preferences } } = this;
      try {
        const { id: campaignID } = this.campaign;
        await this.$apollo.mutate({
          mutation: UpdateCampaignMutation,
          variables: {
            where: { id: campaignID },
            update: {
              preferences: {
                ...(preferences || {}),
                jobRelevancy: this.form['preferences.jobRelevancy'],
                contentRelevancy: this.form['preferences.contentRelevancy'],
              },
            },
          },
        });
        this.$emit('updated');
      } catch (err) {
        this.$log.error(err);
        this.$notification({
          title: 'An error occurred',
          message: err.message,
          variant: 'danger',
        });
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/campaign-admin/update-engagement-details.vue